export const SN_STOCK = 'stock'
export const STOCK_ADD_TO_CACHED_MULTIPLE = SN_STOCK + '/ADD_TO_CACHED_MULTIPLE'
export const STOCK_DETAILS_UPDATED = SN_STOCK+'/STOCK_DETAILS'
export const STOCK_LIST_UPDATED = SN_STOCK+'/LIST_UPDATED'
export const STOCK_CLEARED = SN_STOCK+'/LIST_UPDATED'

